import { useState, useEffect, useRef } from 'react';

export function Timer({
  initialElapsed = 0,
  limit = 600,
  onLimitReached = () => {},
  extraLimit = null,
  onExtraLimitReached = () => {},
  showHours = false,
  onTick = () => {},
  id,
}) {
  const [seconds, setSeconds]  = useState(initialElapsed);
  const onLimitRef             = useRef(onLimitReached);
  const onExtraRef             = useRef(onExtraLimitReached);
  const onTickRef              = useRef(onTick);
  useEffect(() => { onLimitRef.current = onLimitReached; });
  useEffect(() => { onExtraRef.current = onExtraLimitReached; });
  useEffect(() => { onTickRef.current = onTick; });
  const firedRef               = useRef(initialElapsed >= limit);
  const firedExtraRef          = useRef(extraLimit !== null && initialElapsed >= extraLimit);

  useEffect(() => {
    if (initialElapsed >= limit && !firedRef.current) {
      firedRef.current = true;
      setTimeout(() => onLimitRef.current?.(), 0);
    }
    if (extraLimit !== null && initialElapsed >= extraLimit && !firedExtraRef.current) {
      firedExtraRef.current = true;
      setTimeout(() => onExtraRef.current?.(), 0);
    }
    const intervalId = setInterval(() => {
      setSeconds(prev => {
        const next = prev + 1;
        if (next >= limit && !firedRef.current) {
          firedRef.current = true;
          setTimeout(() => onLimitRef.current?.(), 0);
        }
        if (extraLimit !== null && next >= extraLimit && !firedExtraRef.current) {
          firedExtraRef.current = true;
          setTimeout(() => onExtraRef.current?.(), 0);
        }
        setTimeout(() => onTickRef.current?.(next), 0);
        return next;
      });
    }, 1000);
    return () => clearInterval(intervalId);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const over = seconds >= limit;
  const hrs  = Math.floor(seconds / 3600);
  const mins = Math.floor((seconds % 3600) / 60);
  const secs = seconds % 60;
  const display = showHours
    ? `${String(hrs).padStart(2, '0')}:${String(mins).padStart(2, '0')}:${String(secs).padStart(2, '0')}`
    : `${mins}:${String(secs).padStart(2, '0')}`;

  return (
    <div id={id} style={{
      position: 'fixed',
      top: 'calc(var(--app-navbar-height, 41px) + 12px)',
      right: 20,
      zIndex: 1020,
      display: 'inline-flex',
      alignItems: 'center',
      gap: 8,
      padding: '6px 14px',
      borderRadius: 20,
      border: `1.5px solid ${over ? '#dc3545' : '#ced4da'}`,
      background: over ? '#fff5f5' : '#f8f9fa',
      boxShadow: '0 2px 10px rgba(0,0,0,0.15)',
      transition: 'border-color 0.4s, background 0.4s',
    }}>
      <span style={{ fontSize: 18, lineHeight: 1 }}>⏱</span>
      <span style={{
        fontVariantNumeric: 'tabular-nums',
        fontWeight: 700,
        fontSize: 20,
        color: over ? '#dc3545' : '#333',
        transition: 'color 0.4s',
        letterSpacing: '0.5px',
      }}>
        {display}
      </span>
    </div>
  );
}
